

import { useEffect, useState } from "react";
import {
  Button,
  Card,
  Form,
  Select,
  Space,
  Table,
  Tooltip,
  notification,
  Tag,
  Modal
} from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  addResultApprenant,
  getNotesApprenantsV2,
  uploadDocumentAffaire,
  getDocByIdAffaire,
  updateActionAffaire
} from "../../../../api/geoprod";
import { useLoader } from "../../../../context/LoaderContext";
import classes from "../../../Etablissements/Etablissements.module.css";
import Dragger from "antd/es/upload/Dragger";
import { InboxOutlined, EyeOutlined, FileTextOutlined } from "@ant-design/icons";
import CustomUpload from "../../../../utils/CustomUpload";
import { BookOpen, CircleArrowLeft } from "lucide-react";

const { Option } = Select;

const SaisieMention = () => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { setIsLoading } = useLoader();
  const [apprenants, setApprenants] = useState([]);
  const [columns, setColumns] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [selectedApprenant, setSelectedApprenant] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [notesColumns, setNotesColumns] = useState([]);
  const [notesData, setNotesData] = useState([]);
  const params = useLocation();
  const id_affaire = params?.state?.id_affaire;
  const consulterCloture = params?.state?.consulterCloture;
  const modificationMention = params?.state?.modificationMention;
  const navigate = useNavigate();
  const resultatsList = params?.state?.resultatsList ||
    JSON.parse(sessionStorage.getItem("globalData"))?.resultatsList;
  const mentionsList = params?.state?.mentionsList ||
    JSON.parse(sessionStorage.getItem("globalData"))?.mentionsList;
  const [refresh, setRefresh] = useState(false);

  const extractDateFromFileName = (fileName) => {
    const match = fileName?.match(/\d{8}/);
    
    if(fileName?.startsWith("PV_SESSION_FORMATION_HOMOLOGUEE") && match) {
      const dateStr = match[0];
      return new Date(
        parseInt(dateStr?.slice(0, 4)),
        parseInt(dateStr?.slice(4, 6)) - 1,
        parseInt(dateStr?.slice(6, 8))
      );
    }
    return new Date(0);
  };

const showNotesModal = (apprenant) => {
  setSelectedApprenant(apprenant);
  
  form.setFieldsValue({
    ...form.getFieldsValue(),
    apprenants: [{
      resultat: apprenant.decisions?.premier_decision?.id_resultat_apprenant,
      mention: apprenant.decisions?.premier_decision?.id_mention_apprenant
    }]
  });
  
  prepareNotesTable(apprenant);
};

  const prepareNotesTable = (apprenant) => {
    setIsLoading(true);
    
    try {
      const modules = {};
      const annees = apprenant.annees || {};

      Object.entries(annees).forEach(([annee, semestres]) => {
        Object.entries(semestres).forEach(([semestre, semestreData]) => {
          const data = semestreData.data || [];
          
          data.forEach((module) => {
            const noteKey = `${annee}||${semestre}||${module.key_module}`;
            if (!modules[noteKey]) {
              modules[noteKey] = {
                title: `${module.key_module} (Seuil : ${module.seuil} ${module.unite_seuil})`,
                annee,
                semestre,
                key: noteKey,
                seuil: module.seuil,
                tooltip: module.name_module,
              };
            }
          });
        });
      });

      const anneeGroupedColumns = Object.values(modules).reduce((acc, mod) => {
        acc[mod.annee] = acc[mod.annee] || {};
        acc[mod.annee][mod.semestre] = acc[mod.annee][mod.semestre] || [];
        acc[mod.annee][mod.semestre].push({
          title: (
            <Tooltip title={mod.tooltip}>
              <div style={{ textAlign: "center" }}>{mod.title}</div>
            </Tooltip>
          ),
          dataIndex: mod.key,
          key: mod.key,
          render: (val) => {
            const numericVal = parseFloat(val);
            const seuil = parseFloat(mod.seuil);
            const backgroundColor = numericVal >= seuil ? "#DEF7DE" : "#f7dede";

            return (
              <div
                style={{
                  backgroundColor,
                  padding: "8px",
                  textAlign: "center",
                  borderRadius: "4px",
                }}
              >
                {val}
              </div>
            );
          },
        });
        return acc;
      }, {});

      const groupedColumns = Object.entries(anneeGroupedColumns).map(
        ([annee, semestres]) => ({
          title: annee,
          children: Object.entries(semestres).map(([semestre, mods]) => ({
            title: semestre,
            children: mods,
          })),
        })
      );

const decisionColumns = [
  {
    title: "Résultat",
    dataIndex: "resultat",
    key: "resultat",
    render: (_, __, index) => (
      <Form.Item
        name={["apprenants", index, "resultat"]}
        initialValue={selectedApprenant?.decisions?.premier_decision?.id_resultat_apprenant}
      >
      
        <Select 
  options={resultatsList}   
  placeholder="Résultat"      
  style={{ width: "100%" }}
  onChange={(value) => {
  if (value === parseInt(import.meta.env.VITE_APP_ID_STATUS_DECISION_REFUSE_STATUT_APPRENANT)) {
  const currentValues = form.getFieldsValue();
  form.setFieldsValue({
    ...currentValues,
    apprenants: [{
      ...currentValues.apprenants?.[0],
      mention: undefined
    }]
  });
}
  }}
  size="small"
  disabled={selectedApprenant?.decisions?.decision_directeur?.directeur_decision === 1 || consulterCloture}
/> 
      </Form.Item>
    ),
  },
  {
    title: "Mention",
    dataIndex: "mention",
    key: "mention",
    render: (_, __, index) => (
      <Form.Item shouldUpdate={(prevValues, curValues) =>
        prevValues.apprenants?.[index]?.resultat !== curValues.apprenants?.[index]?.resultat
      }>
        {({ getFieldValue }) => {
          const selectedResult = getFieldValue(["apprenants", index, "resultat"]);
          const isDisabled = selectedResult === parseInt(import.meta.env.VITE_APP_ID_STATUS_DECISION_REFUSE_STATUT_APPRENANT) || 
                           selectedApprenant?.decisions?.decision_directeur?.directeur_decision === 1 || 
                           consulterCloture;
          return (
            <Form.Item
              name={["apprenants", index, "mention"]}
              initialValue={selectedApprenant?.decisions?.premier_decision?.id_mention_apprenant}
              rules={[
                {
                  required: selectedResult !== parseInt(import.meta.env.VITE_APP_ID_STATUS_DECISION_REFUSE_STATUT_APPRENANT),
                  message: 'La mention est requise'
                }
              ]}
            >
              <Select
                disabled={isDisabled}
                placeholder="Mention"
                size="small"
                options={mentionsList}
                optionFilterProp="label"
                style={{ width: "100%" }}
              />
            </Form.Item>
          );
        }}
      </Form.Item>
    ),
  }
];

      setNotesColumns([
        { title: "Apprenant", dataIndex: "fullName", key: "fullName", fixed: "left" },
        ...groupedColumns,
        ...decisionColumns,
      ]);

      const notes = {};
      Object.entries(annees).forEach(([annee, semestres]) => {
        Object.entries(semestres).forEach(([semestre, semestreData]) => {
          const data = semestreData.data || [];
          data.forEach((module) => {
            const noteKey = `${annee}||${semestre}||${module.key_module}`;
            notes[noteKey] = module.meilleure_note;
          });
        });
      });

      const apprenantData = {
        key: apprenant.id_apprenant,
        fullName: `${apprenant.name} ${apprenant.surname}`,
        ...notes,
      };

      setNotesData([apprenantData]);
      setIsModalVisible(true);
    } catch (error) {
      notification.error({
        message: t("Erreur"),
        description: t("Erreur lors de la préparation des notes"),
        duration: 0,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      try {
        const response = await getNotesApprenantsV2(id_affaire, {});
        const rawData = response?.meuilleur_note || [];
        
        const showDecisionDirecteur = rawData.some(
          apprenant => apprenant.decisions?.decision_directeur?.directeur_decision !== null
        );
        const showCommentaireDirecteur = rawData.some(
          apprenant => apprenant.decisions?.decision_directeur?.directeur_commentaire
        );

        const apprenantsData = rawData.map(apprenant => ({
          key: apprenant.id_apprenant,
          fullName: `${apprenant.name} ${apprenant.surname}`,
          ...apprenant,
        }));

        const mainColumns = [
          { 
            title: "Apprenant", 
            dataIndex: "fullName", 
            key: "fullName", 
            fixed: "left",
            render: (text, record) => (
      <div style={{
        backgroundColor: record.hasError ? '#fff0f0' : 'transparent',
        padding: '8px',
        borderRadius: '4px',
        border: record.hasError ? '1px solid #ff4d4f' : 'none'
      }}>
        {text}
      </div>
    )
          },
          {
            title: "Résultat",
            dataIndex: "resultat",
            key: "resultat",
            render: (_, record) => (
              record.decisions?.premier_decision?.resultat || "-"
            )
          },
          {
            title: "Mention",
            dataIndex: "mention",
            key: "mention",
            render: (_, record) => (
              record.decisions?.premier_decision?.mention || "-"
            )
          }
        ];

        if (showDecisionDirecteur) {
          mainColumns.push({
            title: "Décision directeur",
            dataIndex: "decisionDirecteur",
            key: "decisionDirecteur",
            render: (_, record) => {
              const value = record.decisions?.decision_directeur?.directeur_decision;
              return value !== null ? (
                <Tag color={value === 1 ? "green" : "red"}>
                  {value === 1 ? "Admis" : "Refusé"}
                </Tag>
              ) : "-";
            }
          });
        }

        if (showCommentaireDirecteur) {
          mainColumns.push({
            title: "Commentaire directeur",
            dataIndex: "commentaireDirecteur",
            key: "commentaireDirecteur",
            render: (_, record) => (
              record.decisions?.decision_directeur?.directeur_commentaire || "-"
            )
          });
        }

        mainColumns.push({
  title: 'Action',
  key: 'action',
  fixed: 'right',
  render: (_, record) => (
    <Space>
      <Tooltip title="Consulter les notes">
        <FileTextOutlined 
          style={{ cursor: 'pointer' }} 
          onClick={() => showNotesModal(record)}
        />
      </Tooltip>
      <Tooltip title="Consulter l'apprenant">
        <EyeOutlined style={{ cursor: 'pointer' }} 
        onClick={() =>
                    {
                      setIsLoading(true)
                    navigate(`/sessionFormationHomologuee/detailsApprenant/${record?.key}`)
                    }
                       }
                    />
      </Tooltip>
    </Space>
  ),
});

        setColumns(mainColumns);
        setApprenants(apprenantsData);

        if (consulterCloture || modificationMention) {
          const formValues = {
            apprenants: apprenantsData.map(apprenant => ({
              resultat: apprenant.decisions?.premier_decision?.id_resultat_apprenant,
              mention: apprenant.decisions?.premier_decision?.id_mention_apprenant,
            })),
          };
          form.setFieldsValue(formValues);
          
          const res = await getDocByIdAffaire(id_affaire);
          const files = res?.data?.find(
            e => e?.md5_id === import.meta.env.VITE_APP_ID_TYPE_DOC_PV_SESSION_FORMATION
          )?.files;
          
          if (files?.length > 0) {
            const sortedFiles = [...files].sort((a, b) => {
              const dateA = extractDateFromFileName(a?.name);
              const dateB = extractDateFromFileName(b?.name);
              return dateB - dateA;
            });

            const latestFile = sortedFiles[0];
            const pvUrl = latestFile?.url_file || null;
            
            setFileList([{
              uid: '-1',
              name: latestFile?.name,
              status: 'done',
              url: pvUrl
            }]);

            form.setFieldsValue({
              pv_session: pvUrl
            });
          }
        }
      } catch (error) {
        notification.error({
          message: t("Erreur"),
          description: t(error?.data?.message || "Erreur lors du chargement des notes"),
          duration: 0,
        });
      } finally {
        setIsLoading(false);
      }
    }

    fetchData();
  }, [refresh]);

  const submitFileAndMentions = (formData, values, newFileName) => {
    uploadDocumentAffaire(formData)
      .then(async (responseUpload) => {
        setFileList([
          {
            uid: "-1",
            name: newFileName,
            status: "done",
            url: responseUpload?.data?.path,
          },
        ]);

        const dataUpdateStatus = await updateActionAffaire({
          id_affaire: id_affaire,
          id_status: import.meta.env
            .VITE_APP_ID_STATUS_EN_ATTENTE_VALIDATION_CLOTURE_SESSION_FORMATION_HOMOLOGUEE,
        });
  if(dataUpdateStatus)
                {
                  notification.success({
                  message: t("Les informations fournies ont été ajoutées avec succès à votre demande"),
                  duration: 6,
                });
                
                navigate(`/session/formations`);
                setIsLoading(false);
              }
              else
               {
                setIsLoading(false)
               }
      })
      .catch((error) => {
        notification.error({
          message: t("Erreur"),
          description: t("Une erreur est survenue lors du téléversement de votre document. Veuillez réessayer."),
          duration: 0,
        });
        setIsLoading(false);
      });
  };


const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
      const apprenantsAvecErreurs = apprenants.filter(apprenant => {
        const decision = apprenant.decisions?.premier_decision;
        return !decision?.id_resultat_apprenant || 
               (decision?.id_resultat_apprenant !== parseInt(import.meta.env.VITE_APP_ID_STATUS_DECISION_REFUSE_STATUT_APPRENANT) && !decision?.id_mention_apprenant);
      });


      if (apprenantsAvecErreurs?.length > 0) {
        const updatedApprenants = apprenants?.map(apprenant => ({
          ...apprenant,
          hasError: apprenantsAvecErreurs.some(a => a?.id_apprenant === apprenant?.id_apprenant)
        }));

        setApprenants(updatedApprenants);

        const errorMessage = apprenantsAvecErreurs?.length === 1
          ? `Veuillez ajouter votre décision pour l'apprenant : ${apprenantsAvecErreurs[0]?.name} ${apprenantsAvecErreurs[0]?.surname}`
          : `Veuillez ajouter vos décisions pour les apprenants : ${apprenantsAvecErreurs?.map(a => `${a?.name} ${a?.surname}`).join(', ')}`;
        setIsLoading(false)

        notification.error({
          message: t("erreur"),
          description: t(errorMessage),
          duration: 0,
        });
        return;
      }

        setIsLoading(true);
        let newFileName = "";
        const formData = new FormData();

        if (fileList[0]?.originFileObj) {
          newFileName = `PV_SESSION_FORMATION_HOMOLOGUEE ${fileList[0].originFileObj?.name}`;
          const renamedFile = new File(
            [fileList[0]?.originFileObj],
            newFileName,
            { type: fileList[0]?.originFileObj?.type }
          );

          formData.append("id_affaire", id_affaire);
          formData.append("id_type_doc", import.meta.env.VITE_APP_ID_TYPE_DOC_PV_SESSION_FORMATION);
          formData.append("name_doc", newFileName);
          formData.append("file[]", renamedFile);

          submitFileAndMentions(formData, values, newFileName);
        } else {
          const fileUrl = fileList[0]?.url;
          newFileName = fileList[0]?.name;

          fetch(fileUrl)
            .then((res) => res.blob())
            .then((blob) => {
              const fileFromUrl = new File([blob], newFileName, { type: blob.type });

              formData.append("id_affaire", id_affaire);
              formData.append("id_type_doc", import.meta.env.VITE_APP_ID_TYPE_DOC_PV_SESSION_FORMATION);
              formData.append("name_doc", newFileName);
              formData.append("file[]", fileFromUrl);

              submitFileAndMentions(formData, values, newFileName);
            })
            .catch(() => {
              notification.error({
                message: t("Erreur"),
                description: t("Impossible de récupérer le fichier."),
                duration: 0,
              });
              setIsLoading(false);
            });
        }
      })
      .catch(() => {
        setIsLoading(false);
        notification.error({
          message: "Erreur",
          description: t("Veuillez vérifier tous les champs."),
        });
      });
  };



  const handleChangeUpload = ({ file, fileList }) => {
    if (file.status !== 'uploading') {
      const newFileList = fileList.slice(-1);
      setFileList(newFileList);
      
      if (newFileList.length === 0) {
        form.setFieldsValue({ pv_session: undefined });
      }
    }
  };
const handleModalSubmit = () => {
  form
    .validateFields([
      ['apprenants', 0, 'resultat'],
      ['apprenants', 0, 'mention']
    ])
    .then((values) => {
      const apprenantData = values.apprenants[0];
      const isRefused = apprenantData.resultat === parseInt(import.meta.env.VITE_APP_ID_STATUS_DECISION_REFUSE_STATUT_APPRENANT);
      
      const data = [{
        id_apprenant: selectedApprenant.id_apprenant,
        id_resultat_apprenant: apprenantData.resultat,
        ...(!isRefused && { id_mention_apprenant: apprenantData.mention })
      }];

      const payload = {
        apprenants: data,
        id_session: id_affaire,
      };

      setIsLoading(true);
      addResultApprenant(payload)
        .then((res) => {
          notification.success({
            message: t("Succès"),
            description: t(res?.message),
          });

          setRefresh(!refresh);
          setIsLoading(false);
          setIsModalVisible(false);
        })
        .catch((error) => {
          notification.error({
            message: t("Erreur"),
            description: t(error?.data?.message),
            duration: 0,
          });
          setIsLoading(false);
        });
    })
    .catch(() => {
      notification.error({
        message: "Erreur",
        description: "Veuillez vérifier les champs obligatoires avant de soumettre.",
      });
    });
};
  return (
    <Form form={form} layout="vertical">
 
         <Button
          className={classes.buttonCreate}
          onClick={() => navigate(-1)}
          style={{marginInline:"16px"}}

        >
          <CircleArrowLeft strokeWidth={1.25} />
          {t("Précédent")}
        </Button>
      
      {!consulterCloture && (
        <Form.Item
          name="pv_session"
          label="Upload pv"
          rules={[{ required: !consulterCloture, message: "Veuillez remplir ce champ." }]}
        >
          <Dragger
            disabled={consulterCloture}
            onChange={handleChangeUpload}
            fileList={fileList}
            beforeUpload={() => false}
            maxCount={1}
            listType="picture"
            accept=".jpg,.jpeg,.png,.pdf"
            onPreview={(file) => {
              if(file?.originFileObj) {
                const url = URL.createObjectURL(file?.originFileObj);
                window.open(url, "_blank");
              } else if (file?.url) {
                window.open(file?.url, "_blank");
              }
            }}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Cliquez ou déposez votre fichier ici pour le télécharger
            </p>
            <p className="ant-upload-hint">
              Formats acceptés : .jpg, .jpeg, .png, .pdf
            </p>
          </Dragger>
        </Form.Item>
      )}
      
      {consulterCloture && fileList[0]?.url && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'white',
          border: '1px solid #f0f0f0',
          borderRadius: "8px 8px 8px 8px ",
          marginBottom:"20px",
          padding: '14px 26px'
        }}>
          <span style={{ 
            marginRight: '16px',
            fontWeight: '500',
          }}>
            PV de la session :
          </span>
          <div>
            <CustomUpload
              field={{
                buttonName: "Ajouter PV",
                name: `PV_SESSION_FORMATION_HOMOLOGUEE`,
              }}
              multiple={false}
              accept=".png,.jpg,.jpeg,.pdf"
              customRequest={null}
              id={"PV_SESSION_FORMATION_HOMOLOGUEE"}
              setSelectedDiplomaFiles={null}
              type="diplome"
              value={fileList[0]?.url}
              showIcon={false}
              style={{ width: '100%' }}
            />
          </div>
        </div>
      )}
      
      <Card 
      title="Liste des apprenants"
      >
        <Table
          dataSource={apprenants}
          columns={columns}
          rowKey="key"
          size="small"
          bordered
          className="compact-table"
          scroll={{ x: "max-content" }}
          pagination={true}
        />
      </Card>
      
      {!consulterCloture && (
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
          <Button key="submit" type="primary" onClick={handleSubmit}>
            Valider
          </Button>
        </div>
      )}
      
      <Modal
        title={`Notes de ${selectedApprenant?.name || ''} ${selectedApprenant?.surname || ''}`}
        open={isModalVisible}
        maskClosable={false}
        destroyOnClose={true}
        onCancel={() => setIsModalVisible(false)}
        width="90%"
 footer={[
  // <Button key="back" onClick={() => setIsModalVisible(false)}>
  //   Annuler
  // </Button>,
  <Button 
    key="submit" 
    type="primary" 
    onClick={handleModalSubmit}
    disabled={selectedApprenant?.decisions?.decision_directeur?.directeur_decision === 1 || consulterCloture}
  >
    Enregistrer
  </Button>,
]}
      >
        <Table
          dataSource={notesData}
          columns={notesColumns}
          rowKey="key"
          size="small"
          bordered
          className="compact-table"
          scroll={{ x: "max-content" }}
          pagination={false}
        />
      </Modal>
    </Form>
  );
};

export default SaisieMention;